<script>
    export default {
        props: {
            packageId: Number,
            packageName: String,
        },
        data() {
            return {
                loading: false,
            }
        },
        methods: {
            deletePackage() {
                this.loading = true;

                axios.delete(Scoop.baseUrl + `/mediaserver/packages/${this.packageId}`).then(response => {
                    if (response.data) {
                        this.$root.$emit('deletedPackage', this.packageId);
                        toastr.success('Package deleted', this.packageName);
                    } else {
                        toastr.error('An error occurred');
                    }

                    this.loading = false;
                });
            }
        },
    }
</script>
<template>
    <Lightbox
            :id="'delete-media-package-'+packageId"
            :headline="'Delete ' + packageName"
            class="inline pull-right"
    >
        <button class="btn btn-danger btn-xs  m-l" slot="open-template">
            <span v-if="loading">Deleting&nbsp;</span>
            <i :class="['fa', loading ? 'fa-cog fa-spin' : 'fa-trash']"></i>
        </button>
        <div slot="body" class="text-center">
            <i class="fa fa-2x fa-exclamation-triangle text-warning m-b"></i>
            <h5>Are you sure that you want to permanently delete the selected item?</h5>
        </div>
        <div v-cloak slot="footer">
            <button type="button" class="btn btn-white pull-left" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="deletePackage">Delete</button>
        </div>
    </Lightbox>
</template>
